import api from '../../../App/socket';

export const getModelStructure = modelName => (
    api.send({
        api: 'module',
        module: 'App',
        classMethod: 'GetModelStructure',
        options: { modelName },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/requests/get_model_structure_request.js